import { useAppDispatch, useAppSelector } from "../store/hooks"
import {
    decreaseOnboardingStep,
    increaseOnboardingStep,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../Onboarding"
import OnboardingContents from "../../onboarding/OnboardingContents"
import Button from "../../component/Button"
import {
    nextOnboardingStepExists,
    previousOnboardingStepExists
} from "../../onboarding/OnboardingController"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import OnboardingDescription from "../../onboarding/OnboardingDescription"
import notNull from "../../util/notNull"

function OnboardingProvider() {
    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const dispatch = useAppDispatch()
    const onboardingStep = useAppSelector(selectOnboardingStep)
    const navigate = useNavigate()
    const location = useLocation()

    const [onboardingDescription, setOnboardingDescription] =
        useState<OnboardingDescription>(OnboardingContents[onboardingStep])

    useEffect(() => {
        setOnboardingDescription(OnboardingContents[onboardingStep])
    }, [onboardingStep])

    useEffect(() => {
        if (
            onboardingIsRunning &&
            notNull(onboardingDescription.forcePath) &&
            location.pathname !== onboardingDescription.forcePath
        ) {
            navigate(onboardingDescription.forcePath)
        }
    }, [location.pathname, onboardingDescription])

    function getPosition(pos: "top_left" | "top_right" | "bottom_left" | "bottom_right" | undefined) {
        const position: "top_left" | "top_right" | "bottom_left" | "bottom_right" = pos ? pos : "top_right"
        if(position === "top_left")
            return "fixed flex-col bg-neutral-800 space-y-6 flex top-[90px] left-[350px] z-10 p-4 border-amber-300 border-4 shadow rounded max-w-[500px]"
        if(position === "top_right")
            return "fixed flex-col bg-neutral-800 space-y-6 flex top-[90px] right-[20px] z-10 p-4 border-amber-300 border-4 shadow rounded max-w-[500px]"
        if(position === "bottom_left")
            return "fixed flex-col bg-neutral-800 space-y-6 flex bottom-[40px] left-[350px] z-10 p-4 border-amber-300 border-4 shadow rounded max-w-[500px]"
        if(position === "bottom_right")
            return "fixed flex-col bg-neutral-800 space-y-6 flex bottom-[40px] right-[20px] z-10 p-4 border-amber-300 border-4 shadow rounded max-w-[500px]"
    }

    return (
        <>
            {onboardingIsRunning && (
                <div
                    className={getPosition(OnboardingContents[onboardingStep].position)}>
                    <div className={"font-bold text-white text-xl"}>
                        {OnboardingContents[onboardingStep].title}
                    </div>
                    <div className={"text-white tracking-widest"}>
                        {OnboardingContents[onboardingStep].content}
                    </div>
                    <div className={"flex"}>
                        <div>
                            {previousOnboardingStepExists(onboardingStep) && (
                                <Button
                                    onClick={() =>
                                        dispatch(decreaseOnboardingStep())
                                    }
                                    textColor={"text-black"}
                                    tint={"bg-amber-300 hover:bg-amber-400"}>
                                    Zurück
                                </Button>
                            )}
                        </div>
                        {!onboardingDescription.hideNextButton && (
                            <div className={"ml-auto"}>
                                <Button
                                    onClick={() =>
                                        dispatch(increaseOnboardingStep())
                                    }
                                    textColor={"text-black"}
                                    tint={"bg-amber-300 hover:bg-amber-400"}>
                                    {nextOnboardingStepExists(onboardingStep)
                                        ? "Weiter"
                                        : "Abschließen"}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default OnboardingProvider
